module.exports = {
    "collapse": ` Skupi`,
    "expand": `Pro\u{161}iri`
};


//# sourceMappingURL=sr-SP.main.js.map
